import {Exclude, Type} from 'class-transformer';

import {BadgeType} from './badge-type';

export abstract class AbstractSerialBadgeType implements BadgeType {
  public name: string = 'serial';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Serial';
  @Exclude({toPlainOnly: true})
  public icon: string = 'slider';
  public frequency: Number;
  public frequencyInRow: Number;
  public range: string;

  constructor() {
  }

  public validate(): string {
    if ( this._isUnsetNumber(this.frequency) && this._isUnsetNumber(this.frequencyInRow) ) {
      return "Es muss wenigesten eine der Häufigkeiten angegeben sein.";
    }
    return null;
  }

  _isUnsetNumber(n:Number) {
    return n === undefined || n === 0;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/badges/abstract-serial-badge-type.ts